// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"187a006d","355":"0afc5cc5","392":"3d1f69f7"}[chunkId] + ".chunk.css";
};